module.exports = __webpack_public_path__ + "static/media/our-story-small-placeholder.b25a9ca4.webp";